// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".round-flight-form-content {\n  padding: 10px;\n  height: calc(100vh - 64px);\n}\n.round-flight-offer-saved-offers-header {\n  padding-top: 50px;\n}\n.round-flight-offer-form-submit {\n  margin-top: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
